import { DmLoadingSpinner } from "../../manager/utils/functions";

const LoadingSkeloton = () => {
  return (
    <div className="flex w-full flex-row rounded-md border border-dm-gray-200 p-6 pr-8 text-dm-gray-200">
      <DmLoadingSpinner message="Loading data..." />
    </div>
  );
};

export default LoadingSkeloton;
